@if (messages().length) {
<section #messageSlider class="keen-slider global-message animated fadeInDown">
  @for (message of messages(); track $index) {
  <div class="keen-slider__slide">
    <span class="global-message__text" [class.line-clamp-1]="message.link?.text && message.link?.url"
      [class.line-clamp-2]="!message.link?.text || !message.link?.url">
      {{message.text}}
    </span>
    @if (message.link?.text && message.link?.url) {
    <a class="global-message__link line-clamp-1" [href]="message.link.url">
      {{message.link.text}}
    </a>
    }
  </div>
  }
</section>
}